<<template>  
  <prop-panel @close="close" :width='"850px"'>
    <p slot="header">生成工资</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-2" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empId"]}}</span>
          <input type="text" class="form-control" readonly v-model="empId" >
        </div>
        <div class="input-group col-md-2" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empName"]}}</span>
          <input type="text" class="form-control" readonly v-model="empName" >
        </div>
        <div class="input-group col-md-3" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate"]}}</span>
          <input type="text" class="form-control" readonly v-model="xdate" >
        </div>
        <div class="col-md-4" style="margin-top: 5px; margin-left: 0;">
          <button @click.stop="prev" :enable="idx>0" title="转到上一行数据" class="btn btn-default">上一行</button>
          <button @click.stop="next" title="转到下一行数据" class="btn btn-default">下一行</button>
          <button @click.stop="generate" title="重新生成该员工当天考勤" class="btn btn-default">生成考勤</button>
        </div>
    </div>
    <hr>
    <div class="row" style="margin-left:0">
      <div class="col-md-3" style="margin-right:20">
        <label class="fui-title" style="width: 150px;border-radius: 4pxc;text-align: center;" >{{rs["rcCard"]}}</label>
        <select size="10" style="width: 150px; height: 150px; ">
          <option v-for="(item, idx) in dk" :value='item.autoid' 
          @dblclick.stop="removeItem(idx, item, 0)">{{fxtime(item.xtime)}}{{item.xuser? " (" + item.xuser + ")":""}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="fui-title" style="width: 150px;border-radius: 4pxc;text-align: center;" >{{rs["nrcCard"]}}</label>
        <select size="10" style="width: 150px; height: 150px; ">
          <option v-for="(item, idx) in ndk" :value='item.autoid' 
          @dblclick.stop="removeItem(idx, item, 1)">{{fxtime(item.xtime)}}{{item.xuser? " (" + item.xuser + ")":""}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="fui-title" style="width: 150px;border-radius: 4px;text-align: center;" >{{rs["rcQJ"]+"/"+rs["rcTX"]}}</label>
        <select size="10" style="width: 150px; height: 150px; ">
          <option v-for="(item, idx) in sj" :value='item'>{{item + " L"}}</option>
          <option v-for="(item, idx) in tx" :value='item'>{{item + " R"}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="fui-title" style="width: 150px;border-radius: 4px;text-align: center;" >{{rs["rcOther"]}}</label>
        <select size="10" style="width: 150px; height: 150px; ">
          <option v-for="(item, idx) in qt" :value='item'>{{item}}</option>
        </select>
      </div>

    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-4" style="margin-left:0">
          <span class="input-group-btn">
            <select class="btn btn-default" v-model="addDay">
              <option value="0">当天</option>
              <option value="1">第二天</option>
            </select>
          </span>
          <date-input ref="gnNo" :formater='"HH:mm"' @keypress.enter="onEnter" class="form-control" v-model="gnNo"/>
          <span class="input-group-btn">
            <button @click.stop="onEnter" class="btn btn-default">补卡</button>
          </span>
        </div>
          <div class="input-group col-md-5" style="margin-left:0">
            <span class="input-group-addon" >指定班次</span>
            <select class="form-control" v-model="shift" @change='onchange($event)'>
              <option value="">---</option>
              <option v-for="item in slist" :value="item.shiftNo">{{item.shiftNo}}/{{item.shiftName}}{{item.groupNo?" G":""}}</option>
            </select>
          </div>
      </div>
        
    </div>
    
  </prop-panel>
</template>

<<script>
export default {
  created(){
    if (this.slist){
      this.slist.forEach(d=>{
        if (d.sel) {
          this.shift = d.shiftNo
          this.shiftV = d.shiftNo
        }
      })
    }
  },
  props:["rs", "url","empIdv", "empNamev","xdatev","dkv","ndkv","sjv","txv","qtv", "slistv", "eidx", "list", "config"],
  data(){
    return {
      gnNo: null,
      addDay:0, 
      shift: "",
      shiftV: "",
      empId: this.empIdv,
      empName: this.empNamev,
      xdate: this.xdatev,
      dk: this.dkv,
      ndk: this.ndkv,
      sj: this.sjv,
      tx: this.txv,
      qt: this.qtv,
      slist: this.slistv,
      idx: this.eidx
    }
  },
  methods:{
    generate(){
        const obj = {
          rq1: this.xdate,
          rq2: this.xdate,
            fillTarget: 3,
            fc: null,
            bc: null,
            dept: null,
            gn: [this.empIdv]
        }

        this.$postData(this.url + "generateAtt", obj, data=>{
          if (data.rs == 1) { 
            this.$loadData(this.config)
            this.$alert("生成成功！")
          }
          else if (data.rs==-9) this.$alert("日报表正在生成中，请稍后再试！")
          else this.$sysError()
        })
    },
    next(){
      if (this.idx==this.list.length-1) return
      this.idx ++
      this.reload()
    },
    prev(){
      if (this.idx==0) return
      this.idx --
      this.reload()
    },
    reload(){
      const item = this.list[this.idx]
      this.$getData(this.url+"Detail?bh="+item.empId +"&rq="+item.xdate + this.$urlSq(), data=>{
        if (data.rs ==1) {
          this.empId= item.empId
          this.empName=item.empName
          this.xdate= this.formatter.fdate(item.xdate)
          this.dk= data.dk
          this.ndk= data.ndk
          this.sj= data.sj
          this.txx=data.txx
          this.qt= data.qt
          this.slist = data.shiftList
        }
      })
    },
    onchange(e, item){
        const data={
          empId: this.empId,
          shiftNo: this.shift,
          shiftName: this.shift,
          bdate: this.xdate
        }
        this.$postData("/shiftEmp/AddFromAtt", data, d=>{
          if (!d.rs) {
            this.$alert("系统错误，请稍后再试！")
            this.shift = this.shiftV
          }
          else this.shiftV = this.shift 
        })
    },
    close: function() {
      this.$emit("close");
    },
    onEnter(e){
      if(this.$trim(this.gnNo) == "") {
        return
      }
      this.$getData(this.url+"AddCard?bh=" + this.empId + "&rq=" 
                    + this.xdate + "&sj=" + this.gnNo + "&addDay=" + this.addDay + this.$urlSq(), data=>{
        if (data.rs==1){
          if (this.addDay ==0) this.$extend(this.dk, data.bc)
          else  this.$extend(this.ndk, data.bc)
          this.gnNo=""
          this.$refs.gnNo.$el.select()
        }
        else{
          this.$alert(this.rs["notFound"])
          this.$refs.gnNo.$el.select()
        }
      })
    },
    removeItem(idx, item, addDay){
      if(this.$confirm("你是否确认删除时间(" + this.formatter.fstime(item.xtime) + ")?")){
        this.$getData(this.url+"DelCard?id=" + item.autoid, data=>{
          if (data.rs==1){
            if (addDay == 0) this.dk.splice(idx,1)
            else this.ndk.splice(idx,1)
          } 
          else this.$sysError()
        })
      }
    },
    fxtime(t) {
        if (!t) return ""
        let h = parseInt(t.substring(11, 13))
        let m = parseInt(t.substring(14, 16))
        const s = parseInt(t.substring(17, 19))
        if (s>=30) m=m+1
        if (m==60){
          m=0
          h=h+1
          if (h==24) h=0
        }
        let hh=''
        if (h<10) hh='0' + h
        else hh=h
        if (m>=10) return hh + ":" + m
        return h + ":0" + m
    }
  }
}
</script>
